let id = 0

export function useId(prefix = 'uid'): string {
  return `${prefix}-${id++}`
}
